import axios from '@axios'

export default {
  loadTable(queryFilter) {
    let queryUrl = ''
    queryUrl = `?page=${queryFilter.page - 1}&size=${queryFilter.size}&sort=${queryFilter.sort},${queryFilter.order}`
    if (queryFilter.filter) {
      queryUrl = `/pesquisa?${queryFilter.filter}`
    }
    return axios.get(`/atendimento/doencas_cids${queryUrl}`)
  },
  insertNew(data) {
    return axios.post('/atendimento/doencas_cids', data)
  },
  edit(data) {
    return axios.put(`/atendimento/doencas_cids/${data.id}`, data)
  },
  delete(id) {
    return axios.delete(`/atendimento/doencas_cids/${id}`)
  },
}
